import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { tokenVerification } from './Utils';
class HealthSystem extends Component {
    constructor() {
        super();
        this.state = {
            dataStartedProcessing: false,
            showLoader: false,
            data: [{
                id: '',
                name: '',
                description: ''
            }],
            hideTextAreaPopup: false,
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            paginationValue: 10,
            editedUserName: "",
            editedDescription: "",
            editedAddress: "",
            editedWebsite: "",
            savedRange: "",
            searchTerm: "",
            noMatchingData: false,
            isLoading: true,
            tableReady: false,
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    componentDidMount = () => {
        const savedPage = localStorage.getItem("lastHealthSystemActivePage");
        if (savedPage !== null) {
            this.restoredPage = parseInt(savedPage);
            localStorage.removeItem("lastHealthSystemActivePage");
        } else {
            this.restoredPage = 1;
        }

        this.fetchHealthSystemDetails();

        if (this.props.location.state != undefined) {
            this.setState({ pageNum: this.props.location.state.pageNum });
        }
    }

    addNewHealthSystemRow = () => {
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            name: '',
            description: '',
        });
        this.setState({
            noMatchingData: false,
            data: this.state.data,
            disabled: true,
        })
    }
    fetchHealthSystemDetails = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/health-system",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.state.disabled = false;
                    thisController.state.showLoader = true;
                    thisController.state.isLoading = false;
                    thisController.state.noMatchingData = false;
                    thisController.state.data = messages;
                    thisController.data = messages;
                    thisController.state.pageNum = thisController.restoredPage || 1;
                    thisController.state.tableReady = true;
                    thisController.setState(thisController.state);
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    saveHealthSystemDetails(row, e) {
        var saveController = this;
        // var namePattern = new RegExp(/^([a-zA-Z\s])*$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
        var addressPattern = new RegExp(/^([a-zA-Z0-9 /''()#.,-])*$/);
        var websitePattern = new RegExp(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/);

        row.name = document.getElementById("name" + row.id).innerText.trim();
        row.description = document.getElementById("description" + row.id).innerText.trim();
        row.address = document.getElementById("address" + row.id).innerText.trim();
        row.website = document.getElementById("website" + row.id).innerText.trim() || saveController.state.editedWebsite.trim();
        //  row.website = saveController.state.editedWebsite;


        var userame = row.name;
        var userDesc = row.description;
        var userAddress = row.address;
        var userWebsite = row.website;
        if (userame == "" || userAddress == "" || userWebsite == "") {
            saveController.notifyEmptyFields();
        }
        else if (!namePattern.test(userame)) {
            saveController.notifyImproperName();
        }
        else if (!websitePattern.test(userWebsite)) {
            saveController.notifyImproperUrl();
        }
        else {
            saveController.state.editedId = "-1";
            saveController.state.dataStartedProcessing = true;
            saveController.setState(saveController.state);
            var saveData = {
                name: row.name,
                description: row.description,
                address: row.address,
                website: row.website
            }

            var timer = setInterval(function () {
                clearTimeout(timer);

                $.ajax({
                    url: "/my-jeeva-api/save-health-system",
                    method: 'POST',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token"),
                        'Content-Type': "application/json",

                    },
                    data: JSON.stringify(saveData),
                    success: function (res) {
                        if (res.success === true) {
                            saveController.state.dataStartedProcessing = false;
                            saveController.fetchHealthSystemDetails();
                            saveController.setState({ disabled: false, dataStartedProcessing: false });
                        } else {
                            saveController.notifyFailedResponse(res.result);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.href = "";
                        }
                    }
                })

            }, 2000);


        }
    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no healthSystem present. </p>
        </div>
    );
    notifyDataProcessing() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Hold on.Your data is saving...
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyImproperDescription() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please avoid numbers & special characters in the description</b>, {
            position: "top-center"
        });
    }

    notifyImproperAddress() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid address</b>, {
            position: "top-center"
        });
    }

    notifyImproperUrl() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid URL</b>, {
            position: "top-center"
        });
    }




    updateHealthSystemDetails(row, e) {
        row.description = document.getElementById("description" + row.id).innerText.trim();
        row.name = document.getElementById("name" + row.id).innerText.trim();
        row.address = document.getElementById("address" + row.id).innerText.trim();
        row.website = document.getElementById("website" + row.id).innerText.trim();
        var updateController = this;

        // var namePattern = new RegExp(/^([a-zA-Z\s])*$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
        var addressPattern = new RegExp(/^([a-zA-Z0-9 /''()#.,-])*$/);
        var websitePattern = new RegExp(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/);

        var username = updateController.state.editedName;
        var userDesc = updateController.state.editedDescription;
        var userAddress = updateController.state.editedAddress;
        var userWebsite = updateController.state.editedWebsite;

        if (username == "" || userAddress == "" || userWebsite == "") {
            updateController.notifyEmptyFields();
        }
        else if (!namePattern.test(username)) {
            updateController.notifyImproperName();
        }
        else if (!addressPattern.test(userAddress)) {
            updateController.notifyImproperAddress();
        }
        else if (!websitePattern.test(userWebsite)) {
            updateController.notifyImproperUrl();
        }
        else {
            var updatedData = {
                id: row.id,
                name: username,
                description: userDesc,
                address: userAddress,
                website: userWebsite
            };
            $.ajax({
                url: "/my-jeeva-api/update-health-system",
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        updateController.state.editedId = "-1";
                        updateController.fetchHealthSystemDetails();
                    } else {
                        updateController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }


            })
        }

    }


    callDeleteHealthSystemApi = (id) => {
        // let healthSystemData = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({
                deleteRow: true,
                hideDeletePopup: false,
                hideDeleteSuccessPopup: true,
                data: this.state.data.filter(item => item.id !== id)
            });
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-health-system/" + id,

                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {
                        deleteApiViewController.setState(prevState => {
                            const updatedData = [...prevState.data];
                            const index = updatedData.findIndex(item => item.id === id);
                            if (index !== -1) {
                                updatedData.splice(index, 1);
                            }
                            return {
                                deleteRow: true,
                                hideDeletePopup: false,
                                data: updatedData
                            };
                        });
                        deleteConstructorVariables.notifyDelete();
                        // healthSystemData.splice(id, 1);
                        // deleteApiViewController.refreshData();
                    } else {
                        // healthSystemData.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        deleteConstructorVariables.fetchHealthSystemDetails();


    }

    makeCelledit(row, e) {
        this.markAsBeingEdited(row.id);
        this.state.editedName = row.name;
        this.state.editedDescription = row.description;
        this.state.editedAddress = row.address;
        this.state.editedWebsite = row.website;
        this.setState(this.state);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }
    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }
    refreshData = (id) => {
        console.log("Resetting the data");
        this.state.isLoading = true;
        this.state.data = [];
        this.state.editedId = "-1";
        this.state.searchTerm = "";
        this.state.disabled = false;
        this.setState(this.state);
        this.fetchHealthSystemDetails();
    }

    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Health System Detail added successfully</b>, {
            position: "top-center",
        });
    }


    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Health System Details updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Health System Detail deleted successfully</b>, {
            position: "top-center",
        });
    }
    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields before saving</b>, {
            position: "top-center"
        });


    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    onPageChange = (e) => {
        this.restoredPage = e;
        this.setState({ pageNum: e });
        localStorage.setItem("lastHealthSystemActivePage", e);
    };

    notifyFailedDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addAdmin = (row, e) => {
        const pageToSave = this.state.pageNum || 1;
        localStorage.setItem("lastHealthSystemActivePage", pageToSave);
        this.props.history.push({
            pathname: '/projectmgmt/health-system-admin',
            state: {
                healthSystemId: row.id,
                pageNum: this.state.pageNum
            }
        });
        this.setState(this.setState)
    }
    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    handleAnchor = (id, name) => {
        window.adminNavigationBar.markActiveTab();
        var existingHealthSystemId = localStorage.getItem('healthSystemId');
        if (existingHealthSystemId != id) {
            localStorage.removeItem("hospitalId");
            localStorage.removeItem("hospitalName");
            localStorage.removeItem("serviceLineId");
            localStorage.removeItem("serviceName");
        }
        localStorage.setItem('healthSystemId', id);
        localStorage.setItem('healthSystemName', name);
        this.props.history.push({
            pathname: "/projectmgmt/hospital",

        });
    }

    openDeletePopUp = (row) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${row.name} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.callDeleteHealthSystemApi(row.id)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    handleDescriptionChange = (e) => {
        this.state.editedDescription = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }
    handleNameChange = (e) => {
        this.state.editedName = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }
    handleAdressChange = (e) => {
        this.state.editedAddress = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }
    handleWebsiteChange = (e) => {
        this.state.editedWebsite = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/search-health-system-data",
            method: "GET",
            data: {
                searchTerm: thisController.state.searchTerm
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.state.noMatchingData = false;
                        thisController.setState(thisController.state);
                        thisController.state.data = res.result;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });

    };

    clearSearchData = () => {
        var thisController = this;
        thisController.setState({ searchTerm: "" }, () => {
            thisController.fetchHealthSystemDetails();
        });
    }


    render() {
        const columns = [
            {
                name: <b style={{ fontSize: '16px' }}> Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('name'),
                selector: (props) => (
                    <div name="name">
                        <a href={props.id == "" || props.id == this.state.editedId ? "javascript:void(0)" : "/my-jeeva/projectmgmt/hospital"}
                            style={{ cursor: props.id == "" || props.id == this.state.editedId ? "default" : 'pointer' }}
                            onClick={() => props.id == "" || props.id == this.state.editedId ? "" : this.handleAnchor(props.id, props.name)}>
                            <div className="textarea health-system-name"
                                style={{
                                    background: 'white', height: "2.7em", resize: 'none',
                                    paddingLeft: '2px', paddingTop: '6px',
                                    width: '100%',
                                    fontSize: '15px', borderRight: '1px solid rgb(189, 186, 194 )',
                                    border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                    borderRadius: (props.id == "") ? '2px' : 'none',

                                }}
                                onInput={(e) => { this.handleNameChange(e) }}
                                id={"name" + props.id}
                                contentEditable={!((props.id == "") ? false : props.id != this.state.editedId) ? "plaintext-only" : false}
                            >
                                {props.name}
                            </div>
                        </a>

                    </div >)
            },
            {
                name: <b style={{ fontSize: '16px' }}>Description</b>,
                sortFunction: this.caseInsensitiveSort('description'),
                sortable: true,
                selector: (props) => (
                    <div name="description">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                width: '100%', fontSize: '15px', borderRight: '1px solid rgb(189, 186, 194 )',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none',
                                overflowY: "scroll"
                            }}
                            onInput={(e) => { this.handleDescriptionChange(e) }}
                            id={"description" + props.id}
                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.description}
                        </div>
                    </div>)
            },
            {
                name: <b style={{ fontSize: '16px' }}>Address</b>,
                sortFunction: this.caseInsensitiveSort("address"),
                sortable: true,
                selector: (props) => (
                    <div name="address">
                        <div className="textarea health-system-address"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                width: '100%', fontSize: '15px', borderRight: '1px solid rgb(189, 186, 194 )',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}
                            onInput={(e) => { this.handleAdressChange(e) }}
                            id={"address" + props.id}
                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.address}
                        </div>
                    </div>)
            }, {
                name: <b style={{ fontSize: '16px' }}>Website</b>,
                sortFunction: this.caseInsensitiveSort("website"),
                sortable: true,
                selector: (props) => (
                    <div name="website">

                        <div className="textarea health-system-website" name="editedwebsite"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                width: '100%', fontSize: '15px', borderRight: '1px solid rgb(189, 186, 194 )',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}
                            onInput={(e) => { this.handleWebsiteChange(e, props) }}
                            id={"website" + props.id}
                            contentEditable={!((props.id == "") ? false : props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.website}
                        </div>
                    </div>)
            },
            {
                name: <b style={{ fontSize: '16px' }}>Actions</b>,
                width: "200px",
                selector: (props) => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginLeft: '-6px' }} >
                            <img className="img-responsive"
                                title={props.id == "" || (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', width: '100%', fontSize: '15px' }}
                                src={props.id == "" ? this.saveImageSrc : ((props.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    this.state.dataStartedProcessing
                                        ? this.notifyDataProcessing() :
                                        props.id == "" ? this.saveHealthSystemDetails(props, e) : (props.id == this.state.editedId) ?
                                            this.updateHealthSystemDetails(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>
                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                title="Delete"//{props.id == "" || (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                onClick={() => (props.id) === '' ?
                                    this.fetchHealthSystemDetails() :
                                    this.openDeletePopUp(props)} /></button >
                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
                        }} title="Admin" onClick={(e) => { this.addAdmin(props, e) }}>
                            <img className="img-responsive" src={"./assets/images/admin.png"}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                            /></button>
                    </div>)
            },
        ]
        return (
            <div id='healthSystemAdminTab' style={{ marginRight: '1%' }}>
                <div style={{ background: "#F9F9FB", display: this.state.showLoader ? 'block' : 'none' }} >
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    <div className="row" style={{ marginLeft: "15px" }}>
                        <div className="col-sm-4" style={{ marginTop: '2px' }} >

                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: '14px' }}>
                        <div className="col-sm-5">
                            <h6 className="nav-item" style={{ color: '#282a65', marginTop: '10px' }}>
                                Health Systems</h6>
                        </div>
                        <div className="col-sm-5" Align="right">
                            <input
                                type="text"
                                style={{
                                    width: "10vw",
                                    border: "1px solid #777676",
                                    borderRadius: "3px",
                                    padding: "10px",
                                    height: "0.6vw",
                                    paddingRight: "2rem",
                                }}
                                value={this.state.searchTerm}
                                onChange={this.handleSearch}
                                placeholder="Search ..."
                            />
                            {this.state.searchTerm && (
                                <span
                                    onClick={() => this.clearSearchData()}
                                    style={{
                                        // position: "absolute",
                                        right: "8px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#777676",
                                        fontSize: "1.2rem",
                                        fontWeight: "bold",
                                        lineHeight: 1,
                                        userSelect: "none",
                                        marginLeft: "-1vw"
                                    }}
                                >
                                    ×
                                </span>
                            )}
                        </div>
                        <div className="col-sm-2 " id='addrefresh-btn' style={{
                            marginTop: '-18px',
                            //  marginLeft: "-2vw" 
                        }}>
                            <div className="d-flex flex-row-reverse pt-2" style={{ marginTop: '-1vh' }}>

                                <div className="p-2" style={{ marginBottom: '15px' }}>

                                    <button className="btn action-button"
                                        id="addMsg" title=" Add "
                                        onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewHealthSystemRow}>
                                        <img src="assets/images/add_white_24dp.png" />
                                    </button>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: '15px', marginTop: '-15px' }}>
                        <div className="col-lg-12 ">
                            {!this.state.noMatchingData &&
                                <div className="card">
                                    {this.state.isLoading && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                            <p>Loading ...</p>
                                        </div>
                                    )}
                                    {!this.state.isLoading && this.state.data.length === 0 && !this.state.noMatchingData && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                            <p>There are no healthSystem present.</p>
                                        </div>
                                    )}
                                    {this.state.data.length > 0 && !this.state.noMatchingData && (
                                        <DataTable
                                            columns={columns}
                                            key={"table-" + this.state.pageNum}
                                            onChangePage={this.onPageChange}
                                            paginationDefaultPage={this.state.pageNum || 1}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            data={this.state.data}
                                            pagination={this.state.paginationValue}
                                            fixedHeaderScrollHeight="400px"
                                            noDataComponent={<this.CustomNoDataComponent />}
                                        />)}


                                </div>
                            }

                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                    <div className='card'>
                        {this.state.noMatchingData &&
                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                <p>No matching options found ...</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default HealthSystem;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/HealthSystem.js